import { Link } from 'react-router-dom'
import { PolygonIcon } from '@/assets'

interface BreadcrumbItem {
  label: string
  href: string
  active?: boolean
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
}

const Breadcrumb = ({ items }: BreadcrumbProps) => {
  return (
    <nav className="flex items-center space-x-1 sm:space-x-2 py-4" aria-label="Breadcrumb">
      {items.map((item, index) => (
        <div key={index} className="flex items-center">
          {index > 0 && (
            <img 
              src={PolygonIcon} 
              alt="" 
              className="mx-2 sm:mx-3 w-2 h-3.5 opacity-80"
            />
          )}
          {item.active ? (
            <span className="text-gray-900 font-medium font-satoshi text-sm">
              {item.label}
            </span>
          ) : (
            <Link 
              to={item.href}
              className="text-forestGreen-100 hover:text-black hover:underline font-semibold font-satoshi transition-colors text-sm"
            >
              {item.label}
            </Link>
          )}
        </div>
      ))}
    </nav>
  )
}

export default Breadcrumb